<template>
  <div class="create-collection-item">
    <div class="form1-wrapper">
      <el-form
        :inline="true"
        label-width="150px"
        style="margin-top: 16px;"
        ref="formRef1"
        :rules="rules1"
        :model="formData1"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="项目部">
              <el-input :value="formData1.projectDeptName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="项目名称">
              <el-input :value="formData1.projectName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="欠款单位">
              <el-input :value="formData1.debtName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="审计及竣工情况">
              <el-select
                v-model="formData1.processStatus"
                placeholder="请选择"
                clearable
                @change="processStatusChange"
              >
                <el-option
                  v-for="process in processStatusList"
                  :key="process.id"
                  :label="process.value"
                  :value="process.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="监理名称">
              <el-input
                v-model="formData1.supervisorName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="审计完结日期">
              <el-date-picker
                v-model="formData1.auditFinishTime"
                type="date"
                placeholder="请选择"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="合同签订日期">
              <el-input :value="formData1.signDate" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="合同工期">
              <el-input :value="formData1.projectTime" disabled>
                <!-- <template slot="append">天</template> -->
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="缺陷责任期限">
              <el-input :value="formData1.liabilityPeriod" disabled>
                <!-- <template slot="append">天</template> -->
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="开工日期(开工令)">
              <el-date-picker
                v-model="formData1.startTime"
                type="date"
                placeholder="请选择"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="合同金额">
              <el-input
                :value="formatMoneyNumber(formData1.contractPrice)"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="税率(%)">
              <el-input-number
                v-model="formData1.taxRate"
                @change="formData1TaxRateChange"
                :precision="2"
                :min="0"
                :max="100"
                controls-position="right"
                clearable
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="不含税合同金额">
              <el-input
                :value="formatMoneyNumber(notTaxContractPrice)"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="审计金额">
              <el-input-number
                v-model="formData1.auditPrice"
                :precision="2"
                :min="0"
                :max="9999999999999"
                controls-position="right"
                clearable
                placeholder="请输入"
                :disabled="formData1.processStatus != 'ysj'"
                @change="auditPriceChange"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="交工日期">
              <el-date-picker
                v-model="formData1.deliveTime"
                type="date"
                placeholder="请选择"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="竣工日期">
              <el-date-picker
                v-model="formData1.finishTime"
                type="date"
                placeholder="请选择"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-wrapper">
      <el-table :data="tableData" border style="width: 100%;" 
    show-summary :summary-method="getSummaries">
        <el-table-column type="index" label="序号" fixed></el-table-column>
        <el-table-column label="期数" prop="number" width="200" fixed></el-table-column>
        <el-table-column label="完成产值" width="200" prop="finishPrice"> 
          <template slot-scope="scope">
            <div>{{formatMoneyNumber(scope.row.finishPrice)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="计量金额" width="200" prop="calculatePrice">
          <template slot-scope="scope">
            <div>{{formatMoneyNumber(scope.row.calculatePrice)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="申请日期" width="200">
          <template slot-scope="scope">
            <div>{{formatYMDstr(scope.row.applyTime)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="批复金额" width="200" prop="replyPrice">
          <template slot-scope="scope">
            <div>{{formatMoneyNumber(scope.row.replyPrice)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="批复时间" width="200">
          <template slot-scope="scope">
            <div>{{formatYMDstr(scope.row.replyTime)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="开具发票金额" width="200" prop="billPrice">
          <template slot-scope="scope">
            <div>{{formatMoneyNumber(scope.row.billPrice)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="销项税金额" width="200">
          <template slot-scope="scope">
            <div>{{formatMoneyNumber(scope.row.outputTaxPrice)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="收款金额" width="200" prop="receiptPrice">
          <template slot-scope="scope">
            <div>{{formatMoneyNumber(scope.row.receiptPrice)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="完成产值占合同比例" width="200">
          <template slot-scope="scope">
            <div>{{formatPercentNumber(scope.row.finishPriceRate)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="计量金额占合同比例" width="200">
          <template slot-scope="scope">
            <div>{{formatPercentNumber(scope.row.calculatePriceRate)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="已批复产值占合同比例" width="200">
          <template slot-scope="scope">
            <div>{{formatPercentNumber(scope.row.replyPriceRate)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="已收款占合同额比例" width="200">
          <template slot-scope="scope">
            <div>{{formatPercentNumber(scope.row.receiptPriceRate)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="应收账款" width="200">
          <template slot-scope="scope">
            <div>{{formatMoneyNumber(scope.row.receiptPlanPrice)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <div>
              <el-button type="text" @click.stop="addItem">添加</el-button>
              <el-button type="text" @click.stop="editItem(scope.row)">编辑</el-button>
              <el-button type="text" @click.stop="deleteItem(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="form2-wrapper">
      <el-form :model="formData2" label-width="150px">
        <p style="font-weight: bold;">应收账款明细</p>
        <el-row>
          <el-col :span="20">
            <el-form-item label="质保金">
              <el-input-number
                v-model="formData2.qaPrice"
                controls-position="right"
                clearable
                :min="0"
                :max="9999999999999"
                :precision="2"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item
              label="需交工验收、审计、竣工验收后应支付工程款(不含质保金）"
              class="long-label"
            >
              <el-input-number
                v-model="formData2.lastProjectPrice"
                controls-position="right"
                clearable
                :min="0"
                :max="9999999999999"
                :precision="2"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item
              label="按进度应支付工程款（欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款）"
              class="long-label"
            >
              <el-input-number
                v-model="formData2.processProjectPrice"
                controls-position="right"
                clearable
                :min="0"
                :max="9999999999999"
                :precision="2"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <p style="font-weight: bold;">按账龄划分金额</p>
        <el-row>
          <el-col :span="20">
            <el-form-item label="1年以内">
              <el-input-number
                v-model="formData2.oneYearPrice"
                controls-position="right"
                clearable
                :min="0"
                :max="9999999999999"
                :precision="2"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="1-2年">
              <el-input-number
                v-model="formData2.oneToTwoYearPrice"
                controls-position="right"
                clearable
                :min="0"
                :max="9999999999999"
                :precision="2"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="2-3年">
              <el-input-number
                v-model="formData2.twoToThreeYearPrice"
                controls-position="right"
                clearable
                :min="0"
                :max="9999999999999"
                :precision="2"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="3年（含）以上">
              <el-input-number
                v-model="formData2.threeYearPrice"
                controls-position="right"
                clearable
                :min="0"
                :max="9999999999999"
                :precision="2"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="内容（应返还时间）">
              <el-input
                v-model="formData2.yearContent"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item
              label="应收账款未返还原因及工作推进情况"
              class="long-label"
            >
              <el-input
                v-model="formData2.notReasonAndProcess"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="责任人">
              <el-input
                v-model="formData2.responseUserName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="预计回收时间">
              <el-date-picker
                v-model="formData2.estimateReceiptTime"
                type="date"
                placeholder="请选择"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="回收比例">
              <el-input
                :value="takeBackRate ? takeBackRate.toFixed(2) : '0'"
                disabled
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 16px;margin-bottom: 16px;text-align: center;">
      <el-button type="primary" @click.stop="submitData">提交</el-button>
      <el-button type="info" @click.stop="cancelSubmit">取消</el-button>
    </div>
    <el-dialog
      :title="dialogTarget ? '编辑' : '添加'"
      :visible.sync="dialogVisible"
      width="1200px"
      class="my-dialog"
    >
      <el-form
        :model="dialogData"
        label-width="180px"
        class="dialog-form"
        :inline="true"
        :rules="rules"
        ref="ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="期数" prop="number">
              <el-input-number
                v-model="dialogData.number"
                placeholder="请输入"
                clearable
                :step-strictly="true"
                :controls="false"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="完成产值">
              <el-input-number
                v-model="dialogData.finishPrice"
                :precision="2"
                :min="0"
                :max="9999999999999"
                controls-position="right"
                clearable
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="计量金额">
              <el-input-number
                v-model="dialogData.calculatePrice"
                :precision="2"
                :min="0"
                :max="9999999999999"
                controls-position="right"
                clearable
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期">
              <el-date-picker
                v-model="dialogData.applyTime"
                type="date"
                placeholder="请选择"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="批复金额">
              <el-input-number
                v-model="dialogData.replyPrice"
                :precision="2"
                :min="0"
                :max="9999999999999"
                controls-position="right"
                clearable
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="批复时间">
              <el-date-picker
                v-model="dialogData.replyTime"
                type="date"
                placeholder="请选择"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开具发票金额">
              <el-input-number
                v-model="dialogData.billPrice"
                :precision="2"
                :min="0"
                :max="9999999999999"
                controls-position="right"
                clearable
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="销项税金额">
              <el-input-number
                v-model="dialogData.outputTaxPrice"
                :precision="2"
                :min="0"
                :max="9999999999999"
                controls-position="right"
                clearable
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收款金额">
              <el-input-number
                v-model="dialogData.receiptPrice"
                :precision="2"
                :min="0"
                :max="9999999999999"
                controls-position="right"
                clearable
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="完成产值占合同比例(%)">
              <el-input-number
                v-model="dialogData.finishPriceRate"
                :precision="2"
                :min="0"
                :max="9999999999999"
                controls-position="right"
                clearable
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="计量金额占合同比例(%)">
              <el-input-number
                v-model="dialogData.calculatePriceRate"
                :precision="2"
                :min="0"
                :max="9999999999999"
                controls-position="right"
                clearable
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="已批复产值占合同比例(%)">
              <el-input-number
                v-model="dialogData.replyPriceRate"
                :precision="2"
                :min="0"
                :max="9999999999999"
                controls-position="right"
                clearable
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="已收款占合同额比例(%)">
              <el-input-number
                v-model="dialogData.receiptPriceRate"
                :precision="2"
                :min="0"
                :max="9999999999999"
                controls-position="right"
                clearable
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应收账款">
              <el-input-number
                v-model="dialogData.receiptPlanPrice"
                :precision="2"
                :min="0"
                :max="9999999999999"
                controls-position="right"
                clearable
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center;">
        
        <el-button type="info" @click.stop="cancelDialog">取消</el-button>
        <el-button type="primary" @click.stop="confirmDialog">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 收款管理-编辑收款记录
 */
import Constants from "@/utils/consts";
import {
  getProcessStatusList,
  getProjectContractData,
  getCollectionDetail,
  editCollectionItem,
} from "../../services/financeService";
import { createCollectionItemDefaultTableItem } from "./utils";
import { formatYMDstr, dateStr2Date } from "../../utils/index";
import { formatMoney, formatPercent } from "./utils";
export default {
  name: "EditCollectionItem",
  data() {
    return {
      id: undefined,
      detailData: {},
      formData1: {},
      formData2: {},
      tableData: [createCollectionItemDefaultTableItem()],
      deptList: [],
      projectList: [],
      processStatusList: [],
      projectContractData: {}, // 项目对应的合同的数据
      notTaxContractPrice: 0, //不含税合同金额
      takeBackRate: 0, // form2的回收比例, 按100算
      finishPrice_sum: 0, //累计完成产值
      calculatePrice_sum: 0, //累计计量金额
      replyPrice_sum: 0, //累计批复金额
      billPrice_sum: 0, //累计开具发票金额
      receiptPrice_sum: 0, //累计收款金额
      dialogVisible: false,
      dialogData: {},
      dialogTarget: undefined,
      rules: {
        number: [{ required: true, message: "请输入期数", trigger: "blur" }],
      },
      rules1: {
        deptId: [
          { required: true, message: "请选择项目部", trigger: "change" },
        ],
        projectId: [
          { required: true, message: "请选择项目名称", trigger: "change" },
        ],
        processStatus: [
          {
            required: true,
            message: "请选择审计及竣工情况",
            trigger: ["blur", "change"],
          },
        ],
        taxRate: [{ required: true, message: "请输入税率", trigger: ["blur"] }],
        startTime: [
          {
            required: true,
            message: "请选择开工日期(开工令)",
            trigger: ["blur", "change"],
          },
        ],
        // supervisorName: [
        //   { required: true, message: "请输入监理名称", trigger: ["blur"] }
        // ]
      },
    };
  },
  methods: {
    getSummaries(params) {
      console.log('合计', params)
      const { columns = [], data = []} = params;
      let sums = [];
      let finishPriceSum = 0;
      let calculatePriceSum = 0;
      let replyPriceSum = 0;
      let billPriceSum = 0;
      let receiptPriceSum = 0;
      data.forEach(item => {
        finishPriceSum += (item.finishPrice || 0)
        calculatePriceSum += (item.calculatePrice || 0)
        replyPriceSum += (item.replyPrice || 0)
        billPriceSum += (item.billPrice || 0)
        receiptPriceSum += (item.receiptPrice || 0)
      })
      sums[0] = '合计';
      sums[2] = this.formatMoneyNumber(finishPriceSum)//完成产值
      sums[3] = this.formatMoneyNumber(calculatePriceSum)//计量金额
      sums[5] = this.formatMoneyNumber(replyPriceSum)//批复金额
      sums[7] = this.formatMoneyNumber(billPriceSum)//开具发票金额
      sums[9] = this.formatMoneyNumber(receiptPriceSum)//收款金额
      return sums
    },
    processStatusChange(value) {
      console.log("change vlaue", value);
      this.formData1.auditPrice = 0;
      // 切换“审计及竣工情况”后，审计金额要清空，这样又会影响回收比例
      // 回收比例的计算会用到审计金额
      this.updateTakeBackRate();
    },
    auditPriceChange(value) {
      // 回收比例的计算会用到审计金额
      console.log("auditPrice change", value);
      this.updateTakeBackRate();
    },
    formatMoneyNumber: formatMoney,
    formatPercentNumber: formatPercent,
    formatYMDstr,
    dateStr2Date,
    getDefaultItem: createCollectionItemDefaultTableItem,
    onActive() {
      // this.id = 14;//测试
      let params = this.tabRouteParam || {};
      if (params.id) {
        this.id = params.id;
      }
      if (!this.id) {
        return;
      }
      this.getProcessStatusListForSelect();
      this.getDetail();
    },
    /**
     * 获取详情数据
     */
    getDetail() {
      getCollectionDetail({ receiptsId: this.id })
        .then((res) => {
          if (Constants.Code_OK == res.code) {
            this.detailData = res.data || {};
            // form1
            let formData1 = {
              projectDeptName: this.detailData.projectDeptName,
              projectName: this.detailData.projectName,
              projectDeptId: this.detailData.projectDeptId, //项目部id
              projectId: this.detailData.projectId, //项目id
              debtName: this.detailData.debtName,
              processStatus: this.detailData.processStatus,
              supervisorName: this.detailData.supervisorName,
              auditFinishTime: this.detailData.auditFinishTime,
              signDate: this.detailData.signDate,
              projectTime: this.detailData.projectTime,
              liabilityPeriod: this.detailData.liabilityPeriod,
              startTime: this.detailData.startTime,
              contractPrice: this.detailData.contractPrice,
              taxRate: this.detailData.taxRate || 0,
              // taxRate: this.detailData.taxRate
              //   ? this.detailData.taxRate * 100
              //   : 0, // sunjian百分比都是传的真的数，要自己转一下
              auditPrice: this.detailData.auditPrice,
              deliveTime: this.detailData.deliveTime,
              finishTime: this.detailData.finishTime,
            };

            this.$set(this, "formData1", formData1);
            this.notTaxContractPrice = this.detailData.notTaxContractPrice; // 详情里带回一次数据，第一次展示可以不用再js算了，后面修改时需要跟着变

            // form2
            let formData2 = {
              qaPrice: this.detailData.qaPrice,
              lastProjectPrice: this.detailData.lastProjectPrice,
              processProjectPrice: this.detailData.processProjectPrice,
              oneYearPrice: this.detailData.oneYearPrice,
              oneToTwoYearPrice: this.detailData.oneToTwoYearPrice,
              twoToThreeYearPrice: this.detailData.twoToThreeYearPrice,
              threeYearPrice: this.detailData.threeYearPrice,
              yearContent: this.detailData.yearContent,
              notReasonAndProcess: this.detailData.notReasonAndProcess,
              responseUserName: this.detailData.responseUserName,
              estimateReceiptTime: this.detailData.estimateReceiptTime,
            };

            this.$set(this, "formData2", formData2);

            // this.takeBackRate = this.detailData.takeBackRate * 100; // sunjian百分比都是传的真的数，要自己转一下
            this.takeBackRate = this.detailData.takeBackRate;
            // table
            if(this.detailData.itemVOList && this.detailData.itemVOList.length) {
              this.tableData = this.detailData.itemVOList
            }
            // sum
            this.finishPrice_sum = this.detailData.finishPriceSum;
            this.calculatePrice_sum = this.detailData.calculatePriceSum;
            this.replyPrice_sum = this.detailData.replyPriceSum;
            this.billPrice_sum = this.detailData.billPriceSum;
            this.receiptPrice_sum = this.detailData.receiptPriceSum;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error, "提示");
        });
    },
    /**
     * 获取可供选择的状态值列表
     */
    getProcessStatusListForSelect() {
      getProcessStatusList()
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.processStatusList = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    formData1TaxRateChange(value) {
      console.log("--taxrate change", value, typeof value);
      console.log(
        "--this.formData1.taxRate",
        this.formData1.taxRate,
        typeof this.formData1.taxRate
      );
      if (this.formData1.taxRate && this.formData1.contractPrice) {
        this.notTaxContractPrice = (
          this.formData1.contractPrice /
          (1 + this.formData1.taxRate / 100)
        ).toFixed(2);
      } else {
        this.notTaxContractPrice = 0;
      }
    },
    formData1TaxRateInput(value) {
      if (isNaN(value)) {
        this.$alert("请输入数字", "提示");
        this.$set(this.formData1, "taxRate", 0);
      } else {
        this.$set(this.formData1, "taxRate", Number(value));
      }
    },
    formData1AuditPriceInput(value) {
      if (isNaN(value)) {
        this.$alert("请输入数字", "提示");
        this.formData1.auditPrice = 0;
      } else {
        this.formData1.auditPrice = value;
      }
    },

    /**
     * 统计表格的累计项
     */
    updateTableSum() {
      let finishPrice_sum = 0; //累计完成产值
      let calculatePrice_sum = 0; //累计计量金额
      let replyPrice_sum = 0; //累计批复金额
      let billPrice_sum = 0; //累计开具发票金额
      let receiptPrice_sum = 0; //累计收款金额
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i];
        finishPrice_sum += item.finishPrice ? item.finishPrice : 0;
        calculatePrice_sum += item.calculatePrice ? item.calculatePrice : 0;
        replyPrice_sum += item.replyPrice ? item.replyPrice : 0;
        billPrice_sum += item.billPrice ? item.billPrice : 0;
        receiptPrice_sum += item.receiptPrice ? item.receiptPrice : 0;
      }
      this.finishPrice_sum = finishPrice_sum.toFixed(2);
      this.calculatePrice_sum = calculatePrice_sum.toFixed(2);
      this.replyPrice_sum = replyPrice_sum.toFixed(2);
      this.billPrice_sum = billPrice_sum.toFixed(2);
      this.receiptPrice_sum = receiptPrice_sum.toFixed(2);
    },
    updateTakeBackRate() {
      if (this.formData1.processStatus == "ysj") {
        if (this.receiptPrice_sum && this.formData1.auditPrice) {
          this.takeBackRate = Number(
            ((100 * this.receiptPrice_sum) / this.formData1.auditPrice).toFixed(
              2
            )
          );
        } else {
          this.takeBackRate = 0.0;
        }
      } else {
        if (this.receiptPrice_sum && this.finishPrice_sum) {
          this.takeBackRate = Number(
            ((100 * this.receiptPrice_sum) / this.finishPrice_sum).toFixed(2)
          );
        } else {
          this.takeBackRate = 0.0;
        }
      }
    },

    addItem() {
      this.dialogTarget = undefined;
      this.dialogData = {
        number: undefined, // 期数
        finishPrice: undefined, //完成产值
        calculatePrice: undefined, //计量金额
        applyTime: undefined, //申请日期
        replyPrice: undefined, //批复金额
        replyTime: undefined, //批复时间
        billPrice: undefined, //开具发票金额
        outputTaxPrice: undefined, //销项税金额
        receiptPrice: undefined, //收款金额.
        finishPriceRate: undefined, //完成产值占合同比例
        calculatePriceRate: undefined, //计量金额占合同比例
        replyPriceRate: undefined, //已批复产值占合同比例
        receiptPriceRate: undefined, //已收款占合同额比例
        receiptPlanPrice: undefined, //应收账款
      };
      this.dialogVisible = true;
    },

    editItem(item) {
      this.dialogTarget = item;
      this.dialogData = { ...item };
      if (!this.dialogData.number) {
        this.dialogData.number = undefined; // 设置成undefined，初始展示时才是空的，否则会展示个0
      }
      this.dialogVisible = true;
    },
    confirmDialog() {
      let self = this;
      let keys = [
        "finishPrice",
        "calculatePrice",
        "replyPrice",
        "billPrice",
        "outputTaxPrice",
        "receiptPrice",
        "finishPriceRate",
        "calculatePriceRate",
        "replyPriceRate",
        "receiptPriceRate",
        "receiptPlanPrice",
      ];
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          keys.forEach((key) => {
            self.$set(
              self.dialogData,
              key,
              isNaN(self.dialogData[key]) ? 0 : parseFloat(self.dialogData[key])
            );
          });
          if (this.dialogTarget) {
            // 如果是编辑
            this.dialogTarget.number = this.dialogData.number;
            this.dialogTarget.finishPrice = this.dialogData.finishPrice;
            this.dialogTarget.calculatePrice = this.dialogData.calculatePrice;
            this.dialogTarget.applyTime = this.dialogData.applyTime;
            this.dialogTarget.replyPrice = this.dialogData.replyPrice;
            this.dialogTarget.replyTime = this.dialogData.replyTime;
            this.dialogTarget.billPrice = this.dialogData.billPrice;
            this.dialogTarget.outputTaxPrice = this.dialogData.outputTaxPrice;
            this.dialogTarget.receiptPrice = this.dialogData.receiptPrice;
            this.dialogTarget.finishPriceRate = this.dialogData.finishPriceRate;
            this.dialogTarget.calculatePriceRate = this.dialogData.calculatePriceRate;
            this.dialogTarget.replyPriceRate = this.dialogData.replyPriceRate;
            this.dialogTarget.receiptPriceRate = this.dialogData.receiptPriceRate;
            this.dialogTarget.receiptPlanPrice = this.dialogData.receiptPlanPrice;
          } else {
            // 如果是添加
            this.tableData.push(this.dialogData);
          }
          // 先更新表格的合计
          this.updateTableSum();
          // 再更新回收比例
          this.updateTakeBackRate();

          console.log("item数据", this.dialogData);
          console.log("table数据", this.tableData);

          this.dialogVisible = false;
          this.dialogTarget = undefined;
          this.dialogData = {};
        } else {
          return false;
        }
      });
    },
    cancelDialog() {
      this.dialogVisible = false;
      this.dialogTarget = undefined;
      this.dialogData = {};
      this.$refs["ruleForm"].resetFields();
    },

    deleteItem(item) {
      this.$confirm("确定要删除该数据吗？", "提示", {
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          let index = this.tableData.indexOf(item);
          if (index != -1) {
            this.tableData.splice(index, 1);
          }
          if (this.tableData.length == 0) {
            let empty = this.getDefaultItem();
            this.tableData.push(empty);
          }
          this.updateTableSum();
          this.updateTakeBackRate();
        })
        .catch(() => {});
    },

    submitData() {
      let status = ['yjgwsj', 'yjg', 'ywgwjg'];
      let index = status.indexOf(this.formData1.processStatus);
      if(index != -1 && !this.formData1.deliveTime) {
        this.$message.warning("请选择交工日期");
        return;
      }

      this.$refs["formRef1"].validate((valid) => {
        if (!valid) {
          return false;
        }
        let params = {};
        params.id = this.id;
        params.processStatus = this.formData1.processStatus;
        params.projectDeptId = this.formData1.projectDeptId;
        params.projectId = this.formData1.projectId;
        params.taxRate = this.formData1.taxRate;
        params.auditFinishTime = this.dateStr2Date(
          this.formData1.auditFinishTime
        );
        params.supervisorName = this.formData1.supervisorName;
        params.auditPrice = this.formData1.auditPrice;
        params.deliveTime = this.dateStr2Date(this.formData1.deliveTime);
        params.estimateReceiptTime = this.dateStr2Date(
          this.formData2.estimateReceiptTime
        );
        params.finishTime = this.dateStr2Date(this.formData1.finishTime);
        let itemList = (this.tableData || []).filter(comp => comp && !!comp.number);
        params.itemList = itemList;
        let self = this;
        params.itemList.forEach((item) => {
          item.replyTime = self.dateStr2Date(item.replyTime);
          item.applyTime = self.dateStr2Date(item.applyTime);
        });
        params.lastProjectPrice = this.formData2.lastProjectPrice;
        params.notReasonAndProcess = this.formData2.notReasonAndProcess;
        params.oneToTwoYearPrice = this.formData2.oneToTwoYearPrice;
        params.oneYearPrice = this.formData2.oneYearPrice;
        params.processProjectPrice = this.formData2.processProjectPrice;
        params.qaPrice = this.formData2.qaPrice;
        params.startTime = this.dateStr2Date(this.formData1.startTime);
        params.threeYearPrice = this.formData2.threeYearPrice;
        params.twoToThreeYearPrice = this.formData2.twoToThreeYearPrice;
        params.yearContent = this.formData2.yearContent;
        params.responseUserName = this.formData2.responseUserName;

        editCollectionItem(params)
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              this.$alert("操作成功", '提示');
              this.closePage();
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {
            this.$alert(error instanceof Error ? error.message : error, "提示");
          });
      });
    },
    cancelSubmit() {
      //  取消就关掉当前页
      this.closePage();
    },
    closePage() {
      this.bus.$emit("tabClose", "editCollection");
      this.bus.$emit("navMenuChange", {
        routeId: "collectionList",
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";
@import "./table.scss";

.create-collection-item {
  background: white;
  padding: 16px;
}

.form1-wrapper {
  /deep/.el-form-item {
    width: 100%;
  }
  /deep/.el-form-item__content {
    width: calc(100% - 150px);
  }

  /deep/.el-select {
    width: 100%;
  }

  /deep/.el-date-editor {
    width: 100%;
  }

  /deep/.el-input-number {
    width: 100%;

    input {
      text-align: left;
    }
  }
}

.form1-wrapper,
.form2-wrapper {
  margin-top: 16px;
}

.form2-wrapper {
  /deep/.el-input-number {
    width: 100% !important;
  }

  /deep/.el-input__inner {
    text-align: left;
  }
}

/deep/.long-label {
  .el-form-item__label {
    line-height: 24px !important;
  }
}

.my-dialog {
  /deep/.el-form-item {
    display: flex;
    width: 100%;
    // background: red;
    justify-content: flex-start;
    align-items: center;

    .el-form-item__label {
      // background: green;
    }

    .el-form-item__content {
      flex: 1;
      // background: blue;
    }

    .el-input-number {
      flex: 1;
      // background: yellow;
      width: 100%;

      input {
        text-align: left;
      }
    }
  }
}
</style>
